import { Checkbox } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { ColorSearch, DocumentTemplateApi, DocumentTemplateGridDto } from "../../../../api";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IDocumentTemplateListPageProps {}

export const DocumentTemplateListPage: React.FunctionComponent<IDocumentTemplateListPageProps> = (props) => {
  const api = useApiService(DocumentTemplateApi);
  const { t } = useTl();
  const history = useHistory();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: DocumentTemplateGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.documentTemplate}/${row.documentTemplateId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.documentTemplate}/${row.documentTemplateId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "templateCode",
      },
      {
        header: () => t(ETLCodes.Description),
        fieldName: "description",
      },
      {
        header: () => t(ETLCodes.HasFrContent),
        fieldName: "frContent",
        alignment: "center",
        render: (row: DocumentTemplateGridDto) => <Checkbox checked={row.frContent} disabled />,
      },
      {
        header: () => t(ETLCodes.HasEnContent),
        fieldName: "enContent",
        alignment: "center",
        render: (row: DocumentTemplateGridDto) => <Checkbox checked={row.enContent} disabled />,
      },
      {
        header: () => t(ETLCodes.HasNlContent),
        fieldName: "nlContent",
        alignment: "center",
        render: (row: DocumentTemplateGridDto) => <Checkbox checked={row.enContent} disabled />,
      },
    ],
    [history, t]
  );

  const searchFunction = React.useCallback((sObj) => api.baseSearch(ColorSearch.fromJS(sObj)), [api]);
  const exportFunction = React.useCallback((sObj) => api.exportXlsFile(ColorSearch.fromJS(sObj)), [api]);

  const getSearchCriterias = React.useCallback(() => api.getSearchCriterias(true), [api]);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getSearchCriterias}
      searchFunction={searchFunction}
      exportFunction={exportFunction}
      sortKeys={{ templateCode: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.DocumentTemplates) }]}
    />
  );
};
